import "./simple-sidebar.scss";

import classNames from "classnames";
import { isNil } from "lodash-es";
import { Tooltip } from "primereact/tooltip";
import { ReactNode, useState } from "react";
import React from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { NavLink } from "react-router-dom";

import { MenuNavigation } from "../menu-navigation.interface";

export interface SimpleSidebarProps {
  children: ReactNode;
  hostClass?: string;
}

export function SimpleSidebar({ children, hostClass }: SimpleSidebarProps) {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <div
      id="SimpleSidebar"
      className={classNames(
        "flex",
        isExpanded ? "w-48" : "w-20",
        "transition-width duration-300 bg-white text-black",
        hostClass
      )}
    >
      <div className="flex flex-col h-full w-full">
        {/* Toggle Button */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={classNames(
            "m-4 p-3 focus:outline-none flex text-2xl",
            !isExpanded ? "justify-center" : "justify-start"
          )}
        >
          <GiHamburgerMenu />
        </button>

        {/* Render Menu Items */}
        <div className="flex-grow">
          {React.Children.map(children, (child) =>
            React.isValidElement(child)
              ? React.cloneElement(child, { isExpanded } as any)
              : child
          )}
        </div>
      </div>
    </div>
  );
}

export const SimpleMenu: React.FC<
  MenuNavigation & { isExpanded?: boolean }
> = ({ title, icon, path, isExpanded = true, onClickCallback }) => {
  const handleClick = () => {
    if (onClickCallback) {
      const menuNav = { title, icon, path };
      onClickCallback(menuNav);
    }
  };
  const menuElement = (
    <>
      <span className="text-2xl">{icon}</span>
      <span
        className={classNames("text-xl", isExpanded ? "ml-2" : "hidden", title)}
      >
        {title}
      </span>
    </>
  );

  if (isNil(path)) {
    return (
      <span
        className={classNames(
          "relative group flex items-center mx-4 my-2 p-3 cursor-pointer transition-colors duration-200 rounded-lg",
          "bg-white text-gray-800 hover:bg-gray-100 hover:text-gray-800"
        )}
      >
        {menuElement}
      </span>
    );
  }

  return (
    <>
      <Tooltip target={`.${title}`} />
      <NavLink
        to={path}
        className={({ isActive }) =>
          `${title} relative group flex items-center mx-4 my-2 p-3 cursor-pointer transition-colors duration-200 rounded-lg ${
            isActive
              ? "bg-gray-100 text-green-800"
              : "bg-white text-gray-800 hover:bg-gray-100 hover:text-gray-800"
          }`
        }
        data-pr-tooltip={title}
        data-pr-position="right"
        onClick={handleClick}
      >
        {menuElement}
      </NavLink>
    </>
  );
};

export default SimpleSidebar;
